import { MoonIcon } from "./icons";

interface MoonProps {
  date: Date;
}

export default function Moon({ date }: MoonProps) {
  if (date.getHours() > 6) {
    return null;
  }

  return (
    <div className="absolute -top-[3px] -right-[3px] flex size-[15px] rounded-full bg-rich-black shadow-0-0-4 shadow-black/50">
      <MoonIcon />
    </div>
  );
}
